export const DASHBOARD_ACTION = {
    RESET_DASHBOARD_STATE: "RESET_DASHBOARD_STATE",
    REQUEST_DASHBOARD_LIST:"REQUEST_DASHBOARD_LIST",
    RESPONSE_DASHBOARD_LIST:"RESPONSE_DASHBOARD_LIST",
    ERROR_DASHBOARD_LIST:"ERROR_DASHBOARD_LIST",

    RESET_EMP_DASHBOARD_STATE: "RESET_EMP_DASHBOARD_STATE",
    REQUEST_EMP_DASHBOARD_LIST:"REQUEST_EMP_DASHBOARD_LIST",
    RESPONSE_EMP_DASHBOARD_LIST:"RESPONSE_EMP_DASHBOARD_LIST",
    ERROR_EMP_DASHBOARD_LIST:"ERROR_EMP_DASHBOARD_LIST",

    RESET_EMP_DASHBOARD_MONTHLY_HOURS_STATE: "RESET_EMP_DASHBOARD_MONTHLY_HOURS_STATE",
    REQUEST_EMP_DASHBOARD_MONTHLY_HOURS_LIST:"REQUEST_EMP_DASHBOARD_MONTHLY_HOURS_LIST",
    RESPONSE_EMP_DASHBOARD_MONTHLY_HOURS_LIST:"RESPONSE_EMP_DASHBOARD_MONTHLY_HOURS_LIST",
    ERROR_EMP_DASHBOARD_MONTHLY_HOURS_LIST:"ERROR_EMP_DASHBOARD_MONTHLY_HOURS_LIST",

    RESET_TIMESHEE_COUNT:"RESET_TIMESHEE_COUNT",
    REQUEST_TIMESHEET_COUNT:"REQUEST_TIMESHEET_COUNT",
    RESPONSE_TIMESHEET_COUNT:"RESPONSE_TIMESHEET_COUNT",
    ERROR_TIMESHEET_COUNT:"ERROR_TIMESHEET_COUNT",

    RESET_EMP_WISHES:"RESET_EMP_WISHES",
    REQUEST_EMP_WISHES:"REQUEST_EMP_WISHES",
    RESPONSE_EMP_WISHES:"RESPONSE_EMP_WISHES",
    ERROR_EMP_WISHES:"ERROR_EMP_WISHES",
   
    RESET_WEEKLY_EFFECIENCY:"RESET_WEEKLY_EFFECIENCY",
    REQUEST_WEEKLY_EFFECIENCY:"REQUEST_WEEKLY_EFFECIENCY",
    RESPONSE_WEEKLY_EFFECIENCY:"RESPONSE_WEEKLY_EFFECIENCY",
    ERROR_WEEKLY_EFFECIENCY:"ERROR_WEEKLY_EFFECIENCY",


};

export const setResetStateWeeklyEfficiency = () => ({
    type: DASHBOARD_ACTION.RESET_WEEKLY_EFFECIENCY,
    data: undefined
});
export const requestWeeklyEfficiency = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_WEEKLY_EFFECIENCY,
    data: params
});
export const responseWeeklyEfficiency = (res) => ({
    type: DASHBOARD_ACTION.RESPONSE_WEEKLY_EFFECIENCY,
    data: res
});
export const errorWeeklyEfficiency = (err) => ({
    type: DASHBOARD_ACTION.ERROR_WEEKLY_EFFECIENCY,
    data: err
});

export const setResetStateDashboardList = () => ({
    type: DASHBOARD_ACTION.RESET_DASHBOARD_STATE,
    data: undefined
});

export const requestDashboardList = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST,
    data: params
});

export const responseDashboardList = (res) => ({
type: DASHBOARD_ACTION.RESPONSE_DASHBOARD_LIST,
data: res
});

export const errorDashboardList = (err) => ({
    type: DASHBOARD_ACTION.ERROR_DASHBOARD_LIST,
    data: err
});

export const setResetStateEmpDashboardList = () => ({
    type: DASHBOARD_ACTION.RESET_EMP_DASHBOARD_STATE,
    data: undefined
});

export const requestEmpDashboardList = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST,
    data: params
});

export const responseEmpDashboardList = (res) => ({ 
    type: DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_LIST,
    data: res
});

export const errorEmpDashboardList = (err) => ({
    type: DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_LIST,
    data: err
});

export const setResetStateEmpDashboardMonthlyHoursList = () => ({
    type: DASHBOARD_ACTION.RESET_EMP_DASHBOARD_MONTHLY_HOURS_STATE,
    data: undefined
});

export const requestEmpDashboardMonthlyHoursList = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_MONTHLY_HOURS_LIST,
    data: params
});

export const responseEmpDashboardMonthlyHoursList = (res) => ({ 
    type: DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_MONTHLY_HOURS_LIST,
    data: res
});

export const errorEmpDashboardMonthlyHoursList = (err) => ({
    type: DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_MONTHLY_HOURS_LIST,
    data: err
});


export const setResetStateTimesheetCount = () => ({
    type: DASHBOARD_ACTION.RESET_TIMESHEE_COUNT,
    data: undefined
});
export const requestTimesheetCount = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_TIMESHEET_COUNT,
    data: params
});
export const responseTimesheetCount = (res) => ({
    type: DASHBOARD_ACTION.RESPONSE_TIMESHEET_COUNT,
    data: res
});
export const errorTimesheetCount = (err) => ({
    type: DASHBOARD_ACTION.ERROR_TIMESHEET_COUNT,
    data: err
}); 

export const setResetSateEmpWishes =() =>({
    type : DASHBOARD_ACTION.RESET_EMP_WISHES,
    data : undefined
});

export const requestEmpWishes = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_EMP_WISHES,
    data: params
});
export const responseEmpWishes = (res) => ({
    type: DASHBOARD_ACTION.RESPONSE_EMP_WISHES,
    data: res
});
export const errorEmpWishes = (err) => ({
    type: DASHBOARD_ACTION.ERROR_EMP_WISHES,
    data: err
});